export default {
  dev: 'development',
  int: 'integration',
  prod: 'production',
  qa: 'questionableactivity'
}



// WEBPACK FOOTER //
// ./src/constants/nodeEnvironments.ts